import React from "react";
import ReactDOM from "react-dom";
import {when} from "mobx";
import "./index.scss";
import App from "./app/App";
import * as serviceWorker from "./serviceWorker";
import {message} from "antd";
import ReactGA from "react-ga4";
import {store} from "@/stores";

async function main() {
  message.config({
    top: 40,
  });

  // https://mtm.dev/google-analytics-react-router/
  if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);

  // Wait for Session to be initialized
  await when(
    () => store.session.initialized,
    () => {
      ReactDOM.render(<App store={store} />, document.getElementById("root"));

      // If you want your app to work offline and load faster, you can change
      // unregister() to register() below. Note this comes with some pitfalls.
      // Learn more about service workers: https://bit.ly/CRA-PWA
      serviceWorker.unregister();
    },
  );
}

main().catch((error) => {
  console.error("Something went wrong when initializing the app in index.ts", error);
  throw error;
});
